import { Container, styled } from "@mui/material";

export const ModalContainer = styled(Container)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	borderRadius: theme.shape.borderRadius,
	overflow: "hidden",
	outline: "none",

	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",

	maxHeight: `calc(100vh - ${theme.spacing(8)})`,
	maxWidth: `calc(100vw - ${theme.spacing(8)})`,

	display: "flex",
	flexDirection: "column",
}));
